import React from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import classes from "../scss/ClientWalletPatientFi.module.scss";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { InputPhone } from "../../../../../../shared/InputPhone/InputPhone";
import { Button } from "../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { useEnrollNewPatient } from "../hooks/useEnrollNewPatient";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { Skeleton } from "../../../../../../shared/Skeleton/Skeleton";

const PatientFiModalPhoneForm = ({ client, onClose }) => {
  const { mutate, isLoading } = useEnrollNewPatient(client.id);

  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    validationSchema: yup.object({
      phoneNumber: yup.string().required(),
    }),
    initialValues: {
      phoneNumber: client.phone,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      mutate(
        {
          phone: values.phoneNumber,
        },
        {
          onSuccess: (response) => {
            onClose();
            uiNotification.success(response.data.message);
          },
          onError: (error) => uiNotification.error(error.response.data.message),
        },
      );
    },
  });

  return (
    <>
      <div className={classes.phoneForm}>
        <InputLabel>Phone Number</InputLabel>
        {client.isLoading ? (
          <Skeleton height={36} />
        ) : (
          <InputPhone
            withSearch
            fullWidth
            variant="legacy-outlined"
            value={values.phoneNumber}
            onChange={(value) => {
              setFieldValue("phoneNumber", `+${value}`);
            }}
            isError={Boolean(errors.phoneNumber)}
          />
        )}
      </div>
      <div className={classes.footerContainer}>
        <Button
          size="small"
          variant="outlined"
          onClick={onClose}
          isDisabled={isLoading || client.isLoading}
        >
          Cancel
        </Button>
        <Button
          size="small"
          onClick={handleSubmit}
          isDisabled={isLoading || client.isLoading}
          leftAdornment={
            isLoading ? <CircularProgress size="tiny" color="white" /> : null
          }
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default PatientFiModalPhoneForm;
